// ✅ FRONTEND: React component for project definition (ProjectDefinition.jsx)

// Početak React komponente za definisanje projekta
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import Modal from "../components/Modal"; // ← putanja zavisi od tvoje strukture
import Attachments from "../components/Attachments";
import { getAuth } from "firebase/auth";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GenerateShareLinkButton from "../components/GenerateShareLinkButton"; // prilagodi putanju
import ProjectTabs from "../components/ProjectTabs";



// Grupišemo polja u sekcije
const groups = [
  {
    id: "basic",
    title: "basicInfo",
    fields: ["projectName", "location"]
  },
  {
    id: "work",
    title: "workDescription",
    fields: ["scope"]
  },
  {
    id: "space",
    title: "space",
    fields: ["spaceType"]
  },
  {
    id: "infrastructure",
    title: "infrastructure",
    fields: ["water", "sewage", "electricity", "ventilation", "windows", "doors"]
  },
  {
    id: "ergonomics",
    title: "ergonomics",
    fields: ["userHeight"]
  },
  {
    id: "elements",
    title: "elements",
    fields: ["elementTypes", "layout"]
  },
  {
    id: "attachments",
    title: "attachments",
    fields: ["drawings"]
  }
];


// Lista dostupnih aktivnosti
const workOptions = [
  { label: "offer", icon: "/icons/Offer.svg" },
  { label: "design", icon: "/icons/design.svg" },
  { label: "documentation", icon: "/icons/documents.svg" },
  { label: "material", icon: "/icons/material.svg" },
  { label: "assembly", icon: "/icons/assembly.svg" },
  { label: "transport", icon: "/icons/transport.svg" },
  { label: "installation", icon: "/icons/install.svg" },
  { label: "dismantling", icon: "/icons/demolition.svg" },
  { label: "wasteRemoval", icon: "/icons/waste.svg" }
];




const LOCAL_STORAGE_KEY = "projectDefinitionFormData";


function AddressAutocomplete({
  apiKey,
  value,
  onTextChange,
  onPlaceSelected,
  includedRegionCodes,
}) {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  // Učitaj Google Maps skriptu ako nije prisutna
  useEffect(() => {
    if (window.google?.maps) return;
    const s = document.createElement("script");
    s.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    s.async = true;
    document.head.appendChild(s);
  }, [apiKey]);

  // Inicijalizuj Autocomplete samo jednom
  useEffect(() => {
    const init = () => {
      if (!window.google?.maps?.places || !inputRef.current) {
        requestAnimationFrame(init);
        return;
      }

      const ac = new google.maps.places.Autocomplete(inputRef.current, {
        fields: ["place_id", "formatted_address", "geometry", "types"],
        componentRestrictions: includedRegionCodes
          ? { country: includedRegionCodes.map((c) => c.toUpperCase()) }
          : undefined,
      });
      autocompleteRef.current = ac;

      ac.addListener("place_changed", () => {
        const place = ac.getPlace();
        const types = place.types || [];
        const loc = place.geometry?.location;
        onPlaceSelected({
          formattedAddress: place.formatted_address,
          lat: loc ? loc.lat() : undefined,
          lng: loc ? loc.lng() : undefined,
          placeId: place.place_id,
          types,
        });
      });
    };

    init();
  }, [includedRegionCodes, onPlaceSelected]);

  // Ne prepisuj unos dok korisnik kuca
  useEffect(() => {
    const el = inputRef.current;
    if (!el) return;
    if (document.activeElement === el) return;
    const next = value || "";
    if (el.value !== next) el.value = next;
  }, [value]);

  return (
    <input
      ref={inputRef}
      type="text"
      placeholder="Unesite adresu…"
      value={value || ""}
      onChange={onTextChange}
      style={{
        width: "100%",
        height: "40px",
        border: "1px solid #e5e7eb",
        borderRadius: "8px",
        outline: 0,
        padding: "0 12px",
        background: "white",
      }}
    />
  );
}


const ProjectDefinition = () => {
  const { t } = useTranslation();
  const auth = getAuth();
  const user = auth.currentUser;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
 


 useEffect(() => {
  const fetchUserRole = async () => {
    if (!user) return;

    try {
      const token = await user.getIdToken();
      const res = await axios.get("https://modularobjects.com/checkout/api/user/me", {
        headers: { Authorization: `Bearer ${token}` }
      });

      const userRoles = res.data.roles || [];
      if (userRoles.includes("admin")) {
        setIsAdmin(true);
        console.log("✅ isAdmin detected from API");
      } else {
        console.log("ℹ️ User is not admin");
      }
    } catch (err) {
      console.error("❌ Failed to fetch roles:", err);
    }
  };

  fetchUserRole();
}, [user]);

useEffect(() => {
  //console.log("👤 isAdmin in ProjectDefinition.jsx:", isAdmin);
}, [isAdmin]);

 //console.log("👤 isAdmin:", isAdmin);

 const [activeTab, setActiveTab] = useState("order");

const getAllTabs = () => {
  const tabs = [{ id: "order", label: "Order" }];
  const scopes = formData.scope || [];
  //console.log("Aktivne scope vrednosti:", scopes); // 👈 test log
  scopes.forEach((activity) => {
    tabs.push({ id: activity, label: t(activity) });
  });
  return tabs;
};



  
  const { projectId: routeProjectId } = useParams();
  const isCreateMode = !routeProjectId || routeProjectId === "new";
const isEditMode = !!routeProjectId && routeProjectId !== "new";
  const [projectId, setProjectId] = useState(
  routeProjectId && routeProjectId !== "new" ? routeProjectId : null
);

  const [formData, setFormData] = useState(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    return saved ? JSON.parse(saved) : {};
    });

   

    useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);


 // Držanje stanja interfejsa (koja grupa je otvorena itd.)
  const [openGroup, setOpenGroup] = useState(null);
  const [showFloor, setShowFloor] = useState(false);
  const [askLift, setAskLift] = useState(false);
  const [manualLogistics, setManualLogistics] = useState(false);
  

  const [projectData, setProjectData] = useState(null);

 







  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({
  title: "",
  message: "",
  confirmText: "OK",
  cancelText: "",
  onConfirm: () => setShowModal(false)
});

  const getDimensionLimits = (unit) => {
    switch (unit) {
      case "mm": return { min: 1000, max: 15000, heightMin: 1500, heightMax: 4000 };
      case "cm": return { min: 100, max: 1500, heightMin: 150, heightMax: 400 };
      case "m": return { min: 1, max: 15, heightMin: 1.5, heightMax: 4 };
      case "in": return { min: 39.37, max: 590.55, heightMin: 59.05, heightMax: 157.48 };
      case "ft": return { min: 3.28, max: 49.21, heightMin: 4.92, heightMax: 13.12 };
      default: return { min: 1, max: 15, heightMin: 1.5, heightMax: 4 };
    }
  };

  const getErgoLimits = (unit) => {
    const convert = (min, max) => {
      switch (unit) {
        case "mm": return { min, max };
        case "cm": return { min: min / 10, max: max / 10 };
        case "m": return { min: min / 1000, max: max / 1000 };
        case "in": return { min: min / 25.4, max: max / 25.4 };
        case "ft": return { min: min / 304.8, max: max / 304.8 };
        default: return { min, max };
      }
    };
    return {
      userHeight: convert(1200, 2200),
      elementHeight: convert(600, 1100),
      upperCabinetDistance: convert(400, 700),
    };
  };

  const isValidSpace = (formData) => {
    if (!formData.spaceType) return true;

    const requiredFields = ["width", "length", "height"];
    if (!requiredFields.every((f) => formData[f] && formData[f] !== "")) return false;

    const unit = formData.unit || "cm";
    const limits = getDimensionLimits(unit);

    const val = (v) => parseFloat(v);

    return (
      val(formData.width) >= limits.min && val(formData.width) <= limits.max &&
      val(formData.length) >= limits.min && val(formData.length) <= limits.max &&
      val(formData.height) >= limits.heightMin && val(formData.height) <= limits.heightMax
    );
  };





  useEffect(() => {
    if (Object.keys(formData).length > 0) {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(formData));
    }
  }, [formData]);


  useEffect(() => {
  const init = async () => {
    if (!user) return;

    if (isCreateMode) {
      setFormData({
        ...initialFormData,
        userId: user.uid
      });
      setProjectId(null);
      return;
    }

    if (isEditMode) {
      try {
        const token = await user.getIdToken();
        const res = await axios.get(
          `https://modularobjects.com/checkout/api/project/${routeProjectId}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        const project = res.data;

        setProjectId(project.id);
        setFormData({
          userId: project.user_id || user.uid,
          projectId: project.id,
          projectName: project.project_name || "",
          location: project.location || "",
          locationLat: project.location_lat ? parseFloat(project.location_lat) : null,
          locationLng: project.location_lng ? parseFloat(project.location_lng) : null,
          locationPlaceId: project.location_place_id || "",
          unit: project.unit || "mm",
          spaceType: project.space_type || "",
          width: project.width || "",
          length: project.length || "",
          height: project.height || "",
          floor: project.floor || "",
          hasLift:
            project.has_lift === null || project.has_lift === undefined
              ? ""
              : String(Number(project.has_lift)),
          manualLogistics: !!project.manual_logistics,
          ergonomicsUnit: project.ergonomics_unit || "cm",
          userHeight: project.user_height || "",
          elementHeight: project.element_height || "",
          upperCabinetDistance: project.upper_cabinet_distance || "",
          availableTopSpace: project.available_top_space || "",
          ergonomicsPriority: project.ergonomics_priority || "",
          scope: project.scope || [],
          scopeNote: project.scope_note || "",
          elementTypes: project.element_types || "",
          layout: project.layout || "",
          water: project.water || "",
          sewage: project.sewage || "",
          electricity: project.electricity || "",
          ventilation: project.ventilation || "",
          windows: project.windows || "",
          doors: project.doors || ""
        });
      } catch (err) {
        console.error("Greška pri učitavanju projekta:", err);
      }
    }
  };

  init();
}, [user, routeProjectId, isCreateMode, isEditMode]);
  
   const convertUnits = (value, fromUnit, toUnit) => {
  const toMm = {
    mm: (v) => v,
    cm: (v) => v * 10,
    m: (v) => v * 1000,
    in: (v) => v * 25.4,
    ft: (v) => v * 304.8,
  };

  const fromMm = {
    mm: (v) => v,
    cm: (v) => v / 10,
    m: (v) => v / 1000,
    in: (v) => v / 25.4,
    ft: (v) => v / 304.8,
  };

  if (isNaN(value)) return null;

  const valueInMm = toMm[fromUnit] ? toMm[fromUnit](parseFloat(value)) : parseFloat(value);
  return fromMm[toUnit] ? fromMm[toUnit](valueInMm) : valueInMm;
};

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "ergonomicsUnit") {
  const oldUnit = formData.ergonomicsUnit || "cm";
  const newUnit = value;

  const convertValue = (v, from, to) => {
  if (!v || isNaN(parseFloat(v))) return "";
  if (from === to) return v;
  return convertUnits(v, from, to).toFixed(1);
};




  setFormData((prev) => ({
  ...prev,
  ergonomicsUnit: newUnit,
  userHeight: convertValue(prev.userHeight, oldUnit, newUnit),
  elementHeight: convertValue(prev.elementHeight, oldUnit, newUnit),
  upperCabinetDistance: convertValue(prev.upperCabinetDistance, oldUnit, newUnit),
  availableTopSpace: convertValue(prev.availableTopSpace, oldUnit, newUnit)
}));
  return;
}

if (name === "unit") {
  const oldUnit = formData.unit || "mm";
  const newUnit = value;

  const convertValue = (v) =>
    v && !isNaN(parseFloat(v)) ? convertUnits(v, oldUnit, newUnit).toFixed(1) : "";

  setFormData((prev) => ({
    ...prev,
    unit: newUnit,
    width: convertValue(prev.width),
    length: convertValue(prev.length),
    height: convertValue(prev.height)
  }));
  return;
}

    if (name === "scope") {
      let current = formData.scope || [];
      if (value === "__all__") {
        if (checked) {
          setFormData((prev) => ({ ...prev, scope: [...workOptions.map(w => w.label)] }));
        } else {
          setFormData((prev) => ({ ...prev, scope: [] }));
        }
      } else {
        if (checked) {
          current = [...current, value];
        } else {
          current = current.filter((item) => item !== value);
        }
        setFormData((prev) => ({ ...prev, scope: current }));
      }
      return;
    }

    setFormData((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "floor") {
        if (parseInt(value) > 2) {
          setAskLift(true);
        } else {
          setAskLift(false);
          delete updated.hasLift;
        }
      }
      return updated;
    });
  };

  const showValidationModal = (message) => {
  setModalContent({
    title: t("validation.title") || "Validation Error",
    message,
    confirmText: t("ok") || "OK",
    cancelText: "",
    onConfirm: () => setShowModal(false)
  });
  setShowModal(true);
};


  const handleUpload = (e) => {
    setFormData((prev) => ({ ...prev, drawings: e.target.files[0] }));
      };

    const countFilled = (fields, groupId) => {
      let extra = 0;
    
    if (groupId === "basic") {
      if ((showFloor || manualLogistics) && formData.floor) extra++;
      if ((showFloor || manualLogistics) && askLift && formData.hasLift !== undefined) extra++;
    }

    if (groupId === "space") {
      if (!formData.spaceType) return 0;
      if (!formData.width || !formData.length || !formData.height) return 0;
    }

    return fields.filter((f) => {
      if (f === "scope") {
        return (formData.scope && formData.scope.length > 0) || (formData.scopeNote && formData.scopeNote.trim() !== "");
      }
      return formData[f] && formData[f] !== "" && formData[f].length !== 0;
    }).length + extra;
   } ;

    const calculateProgress = () => {
    let totalFields = 0;
    let filledFields = 0;

    groups.forEach(group => {
      const groupFieldsCount = group.fields.length;
      let groupExtra = 0;

      if (group.id === "basic") {
        if (showFloor || manualLogistics) {
          groupExtra += 1;
          if (askLift) groupExtra += 1;
        }
      }

      const groupTotal = groupFieldsCount + groupExtra;
      const groupFilled = countFilled(group.fields, group.id);

      totalFields += groupTotal;
      filledFields += Math.min(groupFilled, groupTotal);
    });

    return totalFields > 0 ? Math.round((filledFields / totalFields) * 100) : 0;
    };

   
const initialFormData = {
  unit: "mm",
  ergonomicsUnit: "cm",
  scope: [],
  projectName: "",
  location: "",
  spaceType: "",
  width: "",
  length: "",
  height: "",
  floor: "",
  hasLift: "",
  manualLogistics: false,
  userHeight: "",
  elementHeight: "",
  upperCabinetDistance: "",
  availableTopSpace: "",
  ergonomicsPriority: "",
  elementTypes: "",
  layout: "",
  water: "",
  sewage: "",
  electricity: "",
  ventilation: "",
  windows: "",
  doors: "",
  scopeNote: ""
};
  
  
const submitUpload = async () => {
  const revision = "R1"; // možeš učiniti dinamičkim

  const data = new FormData();
  data.append("attachments", formData.drawings);

  try {
    const response = await axios.post(
      "https://modularobjects.com/checkout/api/upload",
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${await user.getIdToken()}`,
        },
        params: {
          projectId: formData.projectId,
          revision,
        }
      }
    );

    console.log("✅ Upload success:", response.data);
  } catch (err) {
    console.error("❌ Upload error:", err.response?.data || err.message);
  }
};



  // Definicija mapToSnakeCase pre nego što se pozove u handleSubmit
const mapToSnakeCase = (data) => {
  const userId = formData.userId || user.uid;  // Ako nije postavljen, koristi Firebase ID
  if (!data.projectId || !data.userId || !data.projectName) {
    console.error("Nedostaju obavezni podaci u projectData:", data);
    return null;
  }

  return {
    id: data.id,
    project_id: data.projectId,
    user_id: data.userId,
    project_name: data.projectName,
    location: data.location,
    location_lat: data.locationLat,
    location_lng: data.locationLng,
    location_place_id: data.locationPlaceId,
    unit: data.unit,
    space_type: data.spaceType,
    width: data.width,
    length: data.length,
    height: data.height,
    floor: data.floor,
    has_lift: data.hasLift,
    manual_logistics: data.manualLogistics,
    ergonomics_unit: data.ergonomicsUnit,
    user_height: data.userHeight,
    element_height: data.elementHeight,
    upper_cabinet_distance: data.upperCabinetDistance,
    available_top_space: data.availableTopSpace,
    ergonomics_priority: data.ergonomicsPriority,
    element_types: data.elementTypes,
    layout: data.layout,
    scope: data.scope,
    scope_note: data.scopeNote,
    updated_at: new Date().toISOString(),
  };
};


const buildPayload = () => ({
  project_name: formData.projectName?.trim() || null,

  location: formData.location || null,
  location_lat: formData.locationLat ?? null,
  location_lng: formData.locationLng ?? null,
  location_place_id: formData.locationPlaceId || null,

  unit: formData.unit || "mm",
  space_type: formData.spaceType || null,
  width: formData.width || null,
  length: formData.length || null,
  height: formData.height || null,

  floor: formData.floor || null,
  has_lift: formData.hasLift === "" ? null : Number(formData.hasLift),
  manual_logistics: !!formData.manualLogistics,

  ergonomics_unit: formData.ergonomicsUnit || "cm",
  user_height: formData.userHeight || null,
  element_height: formData.elementHeight || null,
  upper_cabinet_distance: formData.upperCabinetDistance || null,
  available_top_space: formData.availableTopSpace || null,
  ergonomics_priority: formData.ergonomicsPriority || null,

  elementTypes: formData.elementTypes || "",
  layout: formData.layout || "",

  water: formData.water || null,
  sewage: formData.sewage || null,
  electricity: formData.electricity || null,
  ventilation: formData.ventilation || null,
  windows: formData.windows || null,
  doors: formData.doors || null,

  scope: formData.scope || [],
  scopeNote: formData.scopeNote || ""
});

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!user) {
    showValidationModal("User is not authenticated");
    return;
  }

  if (!formData.projectName?.trim()) {
    showValidationModal("Project name is required");
    return;
  }

  if ((showFloor || manualLogistics) && !formData.floor) {
    showValidationModal("Floor is required");
    return;
  }

  if (askLift && formData.hasLift === "") {
    showValidationModal("Elevator requirement is missing");
    return;
  }

  const payload = buildPayload();

  try {
    const token = await user.getIdToken();

    if (isCreateMode) {
      const res = await axios.post(
        "https://modularobjects.com/checkout/api/project",
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      const createdProjectId = res.data?.data?.projectId || res.data?.projectId || res.data?.id;

      if (!createdProjectId) {
        throw new Error("Project created but projectId was not returned");
      }

      setProjectId(createdProjectId);
      navigate(`/project/${createdProjectId}`);
      return;
    }

    if (isEditMode) {
      await axios.put(
        `https://modularobjects.com/checkout/api/project/${projectId}`,
        payload,
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      navigate(`/project/${projectId}`);
    }
  } catch (err) {
    console.error("Error while saving project:", err.response?.data || err.message);
    showValidationModal("Failed to save project");
  }
};







  const handleReset = () => {
  setModalContent({
    title: "Resetovanje",
    message: "Da li ste sigurni da želite da resetujete formu? Svi nespačeni podaci će biti izgubljeni.",
    confirmText: "Da",
    cancelText: "Odustani",
    onConfirm: async () => {
      try {
        // Obriši lokalne podatke
        localStorage.removeItem(LOCAL_STORAGE_KEY);
        
        // Resetuj sve state-ove
        setFormData({
          // Zadrži samo osnovne vrednosti koje su potrebne
          userId: user?.uid,
          unit: "mm",
          ergonomicsUnit: "cm"
        });
        
        // Resetuj dodatne state-ove
        setShowFloor(false);
        setAskLift(false);
        setManualLogistics(false);
        
        setShowModal(false);
        
        // Opciono: Obriši projekat sa servera ako želiš potpuni reset
        // await axios.delete(`/api/project/${projectId}`, {
        //   headers: { Authorization: `Bearer ${await user.getIdToken()}` }
        // });
        
      } catch (err) {
        console.error("Reset error:", err);
        showValidationModal("Došlo je do greške prilikom resetovanja");
      }
    }
  });
  setShowModal(true);
};


  const renderGroupContent = (group) => {
    switch (group.id) {
      case "basic":
        return (
          <div className="space-y-4">
            <div>
              <label className="block font-medium">{t("projectName")}:</label>
              <input
                type="text"
                name="projectName"
                value={formData.projectName || ""}
                onChange={handleChange}
                className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
              />
            </div>
            
            <div>
              <label className="block font-medium">{t("location")}:</label>

<AddressAutocomplete
  apiKey={process.env.NEXT_PUBLIC_GMAPS_KEY}  // ili literalni ključ
  value={formData.location || ""}
  includedRegionCodes={["rs", "de"]}          // po želji
  onTextChange={(e) =>
    handleChange({ target: { name: "location", value: e.target.value } })
  }
  onPlaceSelected={(p) => {
    const types = p.types || [];
    const isBuilding =
      types.includes("premise") ||
      types.includes("establishment") ||
      types.includes("subpremise") ||
      types.includes("street_address");

    setShowFloor(isBuilding);
    if (!isBuilding) setAskLift(false);

    setFormData((prev) => ({
      ...prev,
      location: p.formattedAddress || prev.location,
      locationLat: p.lat ?? prev.locationLat,
      locationLng: p.lng ?? prev.locationLng,
      locationPlaceId: p.placeId ?? prev.locationPlaceId,
    }));
  }}
/>


              {formData.location && !showFloor && (
                <div className="mt-2">
                  <label className="inline-flex items-center">
                    <input
                      type="checkbox"
                      checked={manualLogistics}
                      onChange={(e) => {
                        setManualLogistics(e.target.checked);
                        if (!e.target.checked) {
                          const updated = { ...formData };
                          delete updated.floor;
                          delete updated.hasLift;
                          setFormData(updated);
                          setAskLift(false);
                        } else {
                          setFormData((prev) => ({ ...prev, floor: "" }));
                        }
                      }}
                      className="mr-2"
                    />
                    {t("additionalLogisticsInfo")}
                  </label>
                </div>
              )}

              {formData.location && (showFloor || manualLogistics) && (
                <div className="mt-2 space-y-2">
                  <div>
                    <label className="block font-medium">{t("floorNumber")}:</label>
                    <input
                      type="number"
                      name="floor"
                      value={formData.floor || ""}
                      onChange={handleChange}
                      min="0"
                      className="w-full h-10 order rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
                    />
                  </div>
                  {askLift && (
                    <div>
                      <label className="block font-medium">{t("hasElevator")}?</label>
                      <select
  name="hasLift"
  value={formData.hasLift || ""}
  onChange={handleChange}
  className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
>
  <option value="">{t("select")}...</option>
  <option value="1">{t("yes")}</option>
  <option value="0">{t("no")}</option>
</select>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );

      case "work":
        return (
          <div className="space-y-2">
            <label className="block font-medium">{t("scope")}:</label>
            <div className="flex flex-wrap gap-2 max-w-full">
              <button
                type="button"
                className={`border px-3 py-2 rounded font-medium text-sm flex items-center gap-2 transition max-w-full flex-shrink-0 ${
                  formData.scope?.length === workOptions.length
                    ? 'bg-primary-light text-black' : 'bg-white dark:bg-neutral-800 text-black dark:text-white'
                }`}
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    scope: formData.scope?.length === workOptions.length ? [] : workOptions.map((w) => w.label)
                  }))
                }
              >
                ✅ {t("all")}
              </button>

              {workOptions.map(({ label, icon }) => (
                <button
                  key={label}
                  type="button"
                  onClick={() => {
                    const current = formData.scope || [];
                    const updated = current.includes(label)
                      ? current.filter((i) => i !== label)
                      : [...current, label];
                    setFormData((prev) => ({ ...prev, scope: updated }));
                  }}
                  className={`border px-3 py-2 rounded font-medium text-sm flex items-center gap-2 transition ${
                    formData.scope?.includes(label)
                      ? 'bg-primary-light text-black'
                      : 'bg-white dark:bg-neutral-800 text-black dark:text-white'
                  }`}
                >
                  <img src={icon} alt={t(label)} className="w-5 h-5" />
                  {t(label)}
                </button>
              ))}
            </div>
            <input
              type="text"
              name="scopeNote"
              placeholder={t("additionalNotes")}
              value={formData.scopeNote || ""}
              onChange={handleChange}
              className="w-full h-10 order rounded px-3 py-2 mt-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
            />
          </div>
        );

      case "space":
        return (
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
              <div>
                <label className="block font-medium">{t("spaceType")}:</label>
                <select
                  name="spaceType"
                  value={formData.spaceType || ""}
                  onChange={handleChange}
                  className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
                >
                  <option value="">{t("select")}...</option>
                  {Object.entries(t("spaceTypes", { returnObjects: true })).map(([key, value]) => (
                    <option key={key} value={key}>{value}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block font-medium">{t("units_title")}:</label>
                <select
                  name="unit"
                  value={formData.unit || "mm"}
                  onChange={handleChange}
                  className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
                >
                  {Object.entries(t("units", { returnObjects: true })).map(([key, value]) => (
                    <option key={key} value={key}>{value}</option>
                  ))}
                </select>
              </div>
            </div>

            {formData.spaceType && (
              <div className="flex flex-col sm:flex-row gap-4">
                <div className="w-full sm:w-1/3">
                  <label className="block font-medium">{t("width")}:</label>
                  <input
                    type="number"
                    name="width"
                    value={formData.width || ""}
                    onChange={handleChange}
                    min={getDimensionLimits(formData.unit).min}
                    max={getDimensionLimits(formData.unit).max}
                    step="0.1"
                    className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
                  />
                </div>
                <div className="w-full sm:w-1/3">
                  <label className="block font-medium">{t("length")}:</label>
                  <input
                    type="number"
                    name="length"
                    value={formData.length || ""}
                    onChange={handleChange}
                    min={getDimensionLimits(formData.unit).min}
                    max={getDimensionLimits(formData.unit).max}
                    step="0.1"
                    className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
                  />
                </div>
                <div className="w-full sm:w-1/3">
                  <label className="block font-medium">{t("height")}:</label>
                  <input
                    type="number"
                    name="height"
                    value={formData.height || ""}
                    onChange={handleChange}
                    min={getDimensionLimits(formData.unit).heightMin}
                    max={getDimensionLimits(formData.unit).heightMax}
                    step="0.1"
                    className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
                  />
                </div>
              </div>
            )}
          </div>
        );

      case "ergonomics":
  const unit = formData.ergonomicsUnit || "cm";
  const limits = getErgoLimits(unit);
  const roomHeightRaw = parseFloat(formData.height);
const roomHeight = !isNaN(roomHeightRaw)
  ? convertUnits(roomHeightRaw, formData.unit || "mm", unit)
  : null;

  const bottomHeight = parseFloat(formData.elementHeight) || 0;
  const gap = parseFloat(formData.upperCabinetDistance) || 0;
  const topHeight =
  !isNaN(roomHeight) && !isNaN(bottomHeight) && !isNaN(gap)
    ? roomHeight - bottomHeight - gap
    : "";

  return (
    <div className="space-y-4">
      {/* Prvi red */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block font-medium">{t("userHeight")}:</label>
          <input
  type="number"
  name="userHeight"
  value={formData.userHeight || ""}
  onChange={handleChange}
  min={limits.userHeight.min}
  max={limits.userHeight.max}
  className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
/>
        </div>

        <div>
          <label className="block font-medium">{t("units_title")}:</label>
          <select
            name="ergonomicsUnit"
            value={unit}
            onChange={handleChange}
            className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
          >
            {Object.entries(t("units", { returnObjects: true })).map(([key, value]) => (
              <option key={key} value={key}>{value}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block font-medium">{t("priority")}:</label>
          <select
            name="ergonomicsPriority"
            value={formData.ergonomicsPriority || ""}
            onChange={handleChange}
            className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
          >
            <option value="">{t("select")}...</option>
            <option value="user">{t("userBased")}</option>
            <option value="upperFixed">{t("upperFixed")}</option>
          </select>
        </div>
      </div>

      {/* Dugme za kalkulaciju */}
      <div className="flex justify-center">
        <button
          type="button"
          onClick={() => {
  const userHeight = parseFloat(formData.userHeight);
  const heightRaw = parseFloat(formData.height);
  const ergonomicsUnit = formData.ergonomicsUnit || "cm";
  const spaceUnit = formData.unit || "mm";

  // ✔️ Definiši vrednost razmaka u cm
  const gapCm = 50;

  // Konvertuj userHeight u mm
  const userHeightMm = convertUnits(userHeight, ergonomicsUnit, "mm");
  const calculatedMm = Math.round(userHeightMm / 2 + 5); // visina elementa u mm
  const gapMm = convertUnits(gapCm, "cm", "mm");

  // Room height u mm
  const roomHeightMm = !isNaN(heightRaw)
    ? convertUnits(heightRaw, spaceUnit, "mm")
    : null;

  // Računaj top prostor
  const topSpaceMm = !isNaN(roomHeightMm)
    ? roomHeightMm - calculatedMm - gapMm
    : null;

  // Konvertuj nazad u ergonomsku jedinicu
  const elementHeight = convertUnits(calculatedMm, "mm", ergonomicsUnit).toFixed(1);
  const upperGap = convertUnits(gapMm, "mm", ergonomicsUnit).toFixed(1);
  const topSpace = topSpaceMm !== null && topSpaceMm > 0
    ? convertUnits(topSpaceMm, "mm", ergonomicsUnit).toFixed(1)
    : "";

  setFormData((prev) => ({
    ...prev,
    elementHeight,
    upperCabinetDistance: upperGap,
    availableTopSpace: topSpace
  }));

  showValidationModal(`${t("calculationDone")}`);
}}



          className="bg-primary-light text-black font-semibold px-4 py-2 rounded"
        >
          {t("calculateRecommended")}
        </button>
      </div>

      {/* Rezultati */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block font-medium">{t("elementHeight")}:</label>
          <input
            type="number"
            name="elementHeight"
            value={formData.elementHeight || ""}
            onChange={handleChange}
            className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
          />
        </div>

        <div>
          <label className="block font-medium">{t("upperCabinetDistance")}:</label>
          <input
            type="number"
            name="upperCabinetDistance"
            value={formData.upperCabinetDistance || ""}
            onChange={handleChange}
            className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
          />
        </div>

        <div>
          <label className="block font-medium">{t("availableTopSpace")}:</label>
          <input
            type="number"
            readOnly
            value={formData.availableTopSpace || ""}
    className="w-full h-10 border rounded px-3 py-2 bg-neutral-200 dark:bg-neutral-800 text-black dark:text-white"
          />
        </div>
      </div>
    </div>
  );


      case "infrastructure":
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {["water", "sewage", "electricity", "ventilation", "windows", "doors"].map((field) => (
              <div key={field}>
                <label className="block font-medium">{t(field)}:</label>
                <select
                  name={field}
                  value={formData[field] || ""}
                  onChange={handleChange}
                  className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
                >
                  <option value="">{t("select")}...</option>
                  <option value="existing">{t("existing")}</option>
                  <option value="planned">{t("planned")}</option>
                  <option value="none">{t("none")}</option>
                </select>
              </div>
            ))}
          </div>
        );

      case "elements":
        return (
          <div className="space-y-4">
            <div>
              <label className="block font-medium">{t("elementTypes")}:</label>
              <input
                type="text"
                name="elementTypes"
                value={formData.elementTypes || ""}
                onChange={handleChange}
                className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
              />
            </div>
            <div>
              <label className="block font-medium">{t("layout")}:</label>
              <select
                name="layout"
                value={formData.layout || ""}
                onChange={handleChange}
                className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
              >
                <option value="">{t("select")}...</option>
                <option value="linear">{t("linear")}</option>
                <option value="l-shaped">{t("lShaped")}</option>
                <option value="u-shaped">{t("uShaped")}</option>
                <option value="island">{t("island")}</option>
                <option value="custom">{t("custom")}</option>
              </select>
            </div>
          </div>
        );

      case "attachments":
  return <Attachments userId={user?.uid} projectId={formData.projectId} projectName={formData.projectName} />;

      default:
        return null;
    }
  };

const getTabIcon = (tabId) => {
  if (tabId === "order") return "https://modularobjects.com/icons/order.svg"; // dodaj direktno ovde
  const found = workOptions.find((option) => option.label === tabId);
  return found ? found.icon : null;
};


  return (
    <div className="w-full max-w-6xl mx-auto px-4 py-4">
      <h1 className="text-3xl font-bold text-primary-light dark:text-primary-dark mb-4">
  {formData.projectName ? formData.projectName : t("projectDefinition")}
</h1>
<div className="mb-4 border-b border-gray-300">
  <nav className="flex flex-wrap gap-2 max-w-full">
    {getAllTabs().map((tab) => {
  const icon = getTabIcon(tab.id);
  return (
    <button
      key={tab.id}
      onClick={() => setActiveTab(tab.id)}
      className={`flex items-center gap-2 px-4 py-2 font-semibold border-b-2 ${
        activeTab === tab.id
          ? "border-primary-light text-primary-light"
          : "border-transparent text-gray-600"
      }`}
    >
      {icon && (
        <img src={icon} alt={tab.label} className="w-5 h-5" />
      )}
      {tab.label}
    </button>
  );
})}

  </nav>
</div>

      <div className="mb-4 w-full h-10 bg-gray-200 rounded-full h-2">
        <div
          className="bg-primary-light h-2 rounded-full"
          style={{ width: `${calculateProgress()}%` }}
        ></div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-4">
  {activeTab === "order" && (
    <div className="space-y-4">
      {groups.map((group) => {
        const filled = countFilled(group.fields, group.id);
        const total =
          group.fields.length +
          ((showFloor || manualLogistics) && group.id === "basic"
            ? 1 + (askLift ? 1 : 0)
            : 0);
        const allFilled = filled === total;

        return (
          <div key={group.id}>
            <button
              type="button"
              onClick={() =>
                setOpenGroup(openGroup === group.id ? null : group.id)
              }
              className="w-full h-10 bg-gray-100 dark:bg-neutral-800 p-3 rounded font-semibold text-left flex justify-between items-center"
            >
              <span>{t(group.title)}</span>
              <span className="text-sm text-gray-400 flex items-center gap-2">
                {allFilled && <span className="text-green-500">✔</span>}
                {filled}/{total}
              </span>
            </button>

            {openGroup === group.id && (
              <div className="mt-2 p-4 bg-white dark:bg-neutral-900 rounded shadow">
                {renderGroupContent(group)}
              </div>
            )}
          </div>
        );
      })}

<div className="flex gap-4">
    <button
      type="submit"
      className="bg-primary-light text-black font-bold px-4 py-2 rounded"
    >
      {t("save")}
    </button>
    {/* <button
      type="button"
      onClick={handleReset}
      className="bg-red-500 text-white font-bold px-4 py-2 rounded"
    >
      {t("reset")}
    </button> */}
  </div>

<div className="mt-8">
  {formData.projectId ? (
    <GenerateShareLinkButton projectId={formData.projectId} />
  ) : (
    <p className="text-sm text-gray-500">Sačuvaj projekat da bi generisao link.</p>
  )}
</div>

    </div>
  )}

  {formData.projectId && (
  <button
    type="button"
    onClick={() => navigate(`/project/${formData.projectId}/docs`)}
    className="mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
  >
    📄 {t("projectDocumentation")}
  </button>
)}

  {(formData.scope || []).map(
  (activity) =>
    activeTab === activity && (
      <div key={activity} className="space-y-4">
        <h2 className="font-bold text-lg">{t(`project.${activity}`)} {t("details")}</h2>

        {/* ADMIN VIEW – editabilan */}
        {isAdmin ? (
          <>
            <textarea
              name={`activityNote_${activity}`}
              value={formData[`activityNote_${activity}`] || ""}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  [`activityNote_${activity}`]: e.target.value
                }))
              }
              placeholder={t("addDetails")}
              className="w-full h-32 px-3 py-2 border rounded bg-white dark:bg-neutral-900 text-black dark:text-white"
            />

            <select
              name={`activityStatus_${activity}`}
              value={formData[`activityStatus_${activity}`] || ""}
              onChange={handleChange}
              className="w-full h-10 border rounded px-3 py-2 bg-white dark:bg-neutral-900 text-black dark:text-white"
            >
              <option value="">{t("selectStatus")}</option>
              <option value="not_started">{t("notStarted")}</option>
              <option value="in_progress">{t("inProgress")}</option>
              <option value="done">{t("completed")}</option>
            </select>
          </>
        ) : (
          <>
            {/* USER VIEW – samo prikaz ako je završeno */}
            {formData[`activityStatus_${activity}`] === "done" ? (
              <div className="space-y-2">
                <div className="text-sm text-gray-500">
                  <strong>{t("status")}:</strong> {t(formData[`activityStatus_${activity}`])}
                </div>
                <div className="border p-4 bg-neutral-100 dark:bg-neutral-800 rounded">
                  {formData[`activityNote_${activity}`] || t("noInformation")}
                </div>
              </div>
            ) : (
              <div className="text-sm text-gray-400 italic">{t("notAvailableYet")}</div>
            )}
          </>
        )}
      </div>
    )
)}


  
</form>

      {showModal && (
  <Modal
    title={modalContent.title}
    message={modalContent.message}
    confirmText={modalContent.confirmText}
    cancelText={modalContent.cancelText}
    onConfirm={modalContent.onConfirm}
    onClose={() => setShowModal(false)}
  />
)}

 


    </div>
    
  );
  
};

export default ProjectDefinition;